export default __webpack_public_path__ + "assets/fonts/DMSans-Light-01a4.ttf";